export default __webpack_public_path__ + "static/media/IMG_1516.5a3cb159.JPG";